import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import logo from "../assets/walletven.png";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <header className="site-nav canvas">
      <Link to="/" className="site-nav-brand">
        <img src={logo} alt="Walletven" className="site-nav-logo" />
      </Link>

      <div className="site-nav-links">
        {user ? (
          <>
            <nav className="site-nav-links">
              <Link to="/dashboard">Dashboard</Link>
              <Link to="/profile">Mi Perfil</Link>
            </nav>
            <div className="site-nav-user">
              <span className="site-nav-greeting" >Hola, {user.name}</span>
              <button className="btn btn-primary site-nav-cta" onClick={handleLogout}>
                Cerrar sesión
              </button>
            </div>
          </>
        ) : (
          <>
            <nav className="site-nav-links">
              <Link to="/">Inicio</Link>
              <Link to="/register">Abrir Cuenta</Link>
              <a href="/#como-funciona">¿Cómo Funciona?</a>
              <a href="/#faq">Ayuda</a>
            </nav>
            <Link to="/login" className="text-white bg-primary site-nav-cta">
              ENTRAR
            </Link>
          </>
        )}
      </div>

      <Link to="/login" className="site-nav-links2 text-white bg-primary site-nav-cta">
        ENTRAR
      </Link>
    </header>
  );
}